export const cleanPath = (path: string) => {
	return path.match(/\/$/) ? path : path + '/';
};

export const normalizePath = (path: string | number): string => `${path}`.replace(/^\/+|\/+$/g, '');

export const joinPath = (...paths: string[]): string => paths.map(normalizePath).join('/');
